import { deleteMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const DELETE_CAMPAIGN_SUPERADMIN = 'DELETE_CAMPAIGN_SUPERADMIN';
export const DELETE_CAMPAIGN_SUPERADMIN_SUCCESS =
  'DELETE_CAMPAIGN_SUPERADMIN_SUCCESS';
export const DELETE_CAMPAIGN_SUPERADMIN_FAILURE =
  'DELETE_CAMPAIGN_SUPERADMIN_FAILURE';

// Action Creators
export const fetchDeleteCampaignSuperAdmin = () => ({
  type: DELETE_CAMPAIGN_SUPERADMIN,
});

export const fetchDeleteCampaignSuperAdminSuccess = (data) => ({
  type: DELETE_CAMPAIGN_SUPERADMIN_SUCCESS,
  payload: data,
});

export const fetchDeleteCampaignSuperAdminFailure = (error) => ({
  type: DELETE_CAMPAIGN_SUPERADMIN_FAILURE,
  payload: error,
});

// Thunk Function
export const deleteCampaignSuperAdminCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchDeleteCampaignSuperAdmin(data, external));
    try {
      const response = await deleteMethodWithToken(
        url.deleteCampaignListSuperAdmin + external?.id + '/delete/'
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchDeleteCampaignSuperAdminSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchDeleteCampaignSuperAdminFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchDeleteCampaignSuperAdminFailure(error.message));
    }
  };
};
